import React from 'react';
import { Navigation } from '../components/Navigation';
import { HeroSection } from '../components/HeroSection';
import { WelcomeSection } from '../components/WelcomeSection';
import { JourneySection } from '../components/JourneySection';
import { OfferingsSection } from '../components/OfferingsSection';
import { ReviewsSection } from '../components/ReviewsSection';
import { AboutSection } from '../components/AboutSection';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-night-900 text-cream-50 font-sans selection:bg-gold-400 selection:text-night-900" data-id="element-232" data-mp="2kyqhudt3xsiq">
      <Navigation data-id="element-233" data-mp="2fz45s7p0mibi" />
      <main data-id="element-234" data-mp="2g0ozjv3i9x8b">
        <HeroSection data-id="element-235" data-mp="2g0yodfctdycf" />
        <JourneySection data-id="element-236" data-mp="2fxkn6afvzv6k" />
        <WelcomeSection data-id="element-237" data-mp="qkph1ndzyvg0" />
        <OfferingsSection data-id="element-238" data-mp="qjxq4pvchlw2" />
        <ReviewsSection data-id="element-239" data-mp="ql91pbv17xxq" />
        <AboutSection data-id="element-240" data-mp="qmk69dwax9pw" />
        <ContactSection data-id="element-241" data-mp="llw5w1m6ngj0" />
      </main>
      <Footer data-id="element-242" data-mp="lmxrh00trlez" />
    </div>;
}